import * as React from 'react';
import '../../Modals.css';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import ImageContainer from 'src/modules/commons/images/Image.container';

export interface Props {
  logo?: string;
  modalRef?: Modal;
}

class InvestmentFunnelHeaderComponent extends React.PureComponent<Props> {

  public render(): React.ReactNode {
    return (
      <div className="investment-funnel-header">
        <span
          className="close-med pointer"
          onClick={() => this.props.modalRef!.modal('hide')}
        />
        <ImageContainer
          alt="logo"
          url={this.props.logo}
        />
        <hr/>
      </div>
    );
  }
}

export default InvestmentFunnelHeaderComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/partials/InvestmentFunnelHeader.component.tsx